import React, { useContext, useEffect, useState } from "react";
import { Heading, SectionHeading, Textarea } from "../../../components";
import { ResumeContext } from "../../../contexts/resumeContext";

function LanguageForm() {
  const {updateResumeInfo, resumeInfo} = useContext(ResumeContext);
  
  const [languages, setLanguages] = useState(resumeInfo?.misc?.languages || '')

  useEffect(() => {
    const miscSection = {...resumeInfo.misc}
    miscSection['languages'] = languages
    
    updateResumeInfo.current("misc", miscSection, resumeInfo);
  }, [languages]);

  return (
    <>
      <SectionHeading editable content="Languages" section="LAN"/>
      <Textarea
        label="What languages do you know?"
        rows={5}
        value={languages}
        onChange={(e) => setLanguages(e.target.value)}
        placeholder="e.g. Hindi, French, German"
      />
    </>
  );
}

export default LanguageForm
